import { render, staticRenderFns } from "./ListagemSupportTeamMembers.vue?vue&type=template&id=356b3338"
import script from "./ListagemSupportTeamMembers.vue?vue&type=script&lang=js"
export * from "./ListagemSupportTeamMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports